import gql from 'graphql-tag';

export const CTGLoyaltyWalmartUserUnlink = gql`
  mutation ctgLoyaltyWalmartUserUnlink($loyaltyId: String!) {
    ctgLoyaltyWalmartUserUnlink(loyaltyId: $loyaltyId) {
      success
    }
  }
`;
